import gtmConfig from './gtm.json';

export const RAID2026_GTM_CONTAINER_ID = gtmConfig.raid2026ContainerId;

const GTM_HEAD_SCRIPT_MARKER = 'data-gtm-head';
const GTM_BODY_NOSCRIPT_MARKER = 'data-gtm-noscript';

export const getRaid2026GtmHeadScriptHtml = (
  containerId = RAID2026_GTM_CONTAINER_ID
) => `<!-- Google Tag Manager -->
<script ${GTM_HEAD_SCRIPT_MARKER}>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${containerId}');</script>
<!-- End Google Tag Manager -->`;

export const getRaid2026GtmBodyNoscriptHtml = (
  containerId = RAID2026_GTM_CONTAINER_ID
) => `<!-- Google Tag Manager (noscript) -->
<noscript ${GTM_BODY_NOSCRIPT_MARKER}><iframe src="https://www.googletagmanager.com/ns.html?id=${containerId}"
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
<!-- End Google Tag Manager (noscript) -->`;

export const GTM_DOM_MARKERS = {
  headScript: GTM_HEAD_SCRIPT_MARKER,
  bodyNoscript: GTM_BODY_NOSCRIPT_MARKER,
};
